export const SCOPE = {
  MINE: "mine",
  DISCOVER: "discover",
};

export const SCOPE_TABS = [
  { value: SCOPE.MINE, label: "Mine" },
  { value: SCOPE.DISCOVER, label: "Discover" },
];
